<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group v-if="Yetki" class="float-right">
        <router-link tag="button" to="/muhasebe/kasa" class="el-button YeniBtn el-button--small"
        >Kasalar
        </router-link>
        <el-button type="info" size="small" class="YeniBtn" @click="this.YeniBtn">{{ Sayfa.YeniAdi }}
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-row :gutter="24">
        <el-col :span="19">
          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız">
          </el-alert>
          <el-table
            v-if="tableDisplay"
            ref="multipleTable"
            class="table-xs"
            :data="tableData"
            :height="Height">
            <el-table-column
              label="Bina"
              prop="Bina">
            </el-table-column>
            <el-table-column
              label="İşlem Tarihi"
              prop="iTarihiText"
              width="150">
            </el-table-column>
            <el-table-column
              label="Tutar"
              prop="Tutar"
              width="150">
            </el-table-column>
            <el-table-column
              label="Devir Alan"
              prop="G_Kasa"
              width="200">
            </el-table-column>
            <el-table-column
              label="Devir Eden"
              prop="C_Kasa"
              width="200">
            </el-table-column>
            <el-table-column
              label="Kullanıcı"
              prop="Kullanici"
              width="100">
            </el-table-column>

            <el-table-column
              align="right">
              <template slot-scope="scope">
                <el-button-group>
                  <el-tooltip v-if="Yetki" class="item" effect="dark" content="Düzenle"
                              placement="top-start">
                    <i
                      class="feather-edit-2  tableibtn text-primary"
                      @click="DuzenleBtn(scope.row.id)">
                    </i>
                  </el-tooltip>
                  <el-tooltip v-if="Yetki" class="item" effect="dark"
                              content="Sil"
                              placement="top-start">
                    <i
                      class="feather-trash tableibtn text-danger"
                      @click="SilOnay(scope.row.id)">
                    </i>
                  </el-tooltip>
                </el-button-group>
              </template>
            </el-table-column>

          </el-table>
        </el-col>
        <el-col :span="5">
          <el-collapse class="Filtre" v-model="FiltreCollapse">
            <el-collapse-item :title="Sayfa.FiltreAdi" name="1">
              <el-form :rules="FormHata" :model="Form"
                       @submit.prevent.native="Getir"
                       ref="FiltreForm">
                <div v-if="!Form.mNo">
                  <el-form-item label="Site / Bina" prop="Bina_id">
                    <el-select v-model="Form.Bina_id" filterable clearable>
                      <el-option-group
                        label="Site Listesi">
                        <el-option
                          v-for="item in Siteler"
                          :key="item.id"
                          :label="item.Adi"
                          :value="item.id">
                        </el-option>
                      </el-option-group>
                      <el-option-group
                        label="Bina Listesi">
                        <el-option
                          v-for="item in Binalar"
                          :key="item.id"
                          :label="item.Adi"
                          :value="item.id">
                        </el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="İşlem Tarih Aralığı" prop="Tarih">
                    <el-date-picker
                      v-model="Form.Tarih"
                      type="daterange"
                      range-separator="-"
                      start-placeholder="Başlangıç Tarihi"
                      end-placeholder="Bitiş Tarihi"
                      format="dd.MM.yyyy"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
                <el-button type="primary" class="btn-block" size="medium" @click="Getir()"
                           icon="el-icon-check">Virmanları Getir
                </el-button>
              </el-form>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      :title="Baslik"
      :visible="ModalOlayi"
      center
      width="50%">
      <Yukleniyor :data="lo"></Yukleniyor>
      <a @click="ModalOlayi=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-form :model="FormData" @submit.prevent.native="Submit" :rules="FormDataHata" ref="Form">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Devir Alan Kasa" prop="G_Kasa_id">
              <el-cascader
                collapse-tags
                placeholder="Kasa Seçiniz"
                :props="{ multiple: false}"
                :options="Kasalar"
                v-model="FormData.G_Kasa_id"
                filterable></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Devir Eden Kasa" prop="C_Kasa_id">
              <el-cascader
                collapse-tags
                placeholder="Kasa Seçiniz"
                :props="{ multiple: false}"
                :options="Kasalar"
                v-model="FormData.C_Kasa_id"
                filterable></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Virman Tutarı" prop="Tutar">
              <el-input
                placeholder="Tutar"
                v-model="FormData.Tutar">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="İşlem Tarihi" prop="iTarihi">
              <el-date-picker
                v-model="FormData.iTarihi"
                type="date"
                format="dd.MM.yyyy"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Site / Bina" prop="Bina_id">
              <el-select v-model="FormData.Bina_id" @change="KasaGetir()" filterable clearable>
                <el-option-group
                  label="Site Listesi">
                  <el-option
                    v-for="item in Siteler"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-option-group>
                <el-option-group
                  label="Bina Listesi">
                  <el-option
                    v-for="item in Binalar"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="Submit()" icon="el-icon-check">
          {{ $t('eGenel.0') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      FiltreCollapse: '1',
      Yetki: false,
      lo: false,
      ModalOlayi: false,
      Height: window.innerHeight - 150,
      Kaydet: false,
      Sayfa: {
        YeniAdi: 'Yeni Virman',
        Adi: 'Virman',
        ButtonAdi: 'Uygula',
        FiltreAdi: 'Filtreleme',
      },
      Form: {
        Bina_id: null,
        Tarih: [],
        mNo: null,
        Kasa_id: null,
        Tur: 1,
      },
      FormHata: {
        Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      MakbuzDetayModal: false,
      mNo: null,
      Bina_id: null,
      Kasalar: [],
      Binalar: [],
      Siteler: [],
      tableData: [],
      tableDisplay: false,
      FormDataHata: {
        C_Kasa_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        G_Kasa_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Tutar: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        iTarihi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}]
      },
      FormData: {
        id: null,
        C_Kasa_id: null,
        G_Kasa_id: null,
        Tutar: null,
        iTarihi: new Date(),
        Bina_id: null,
      }
    }
  },
  methods: {
    SilOnay(id) {
      this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.Sil(id)
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    Sil(id) {
      this.lo = true
      this.$store.dispatch("Delete", {...this.Form, path: 'muhasebe/virman/' + id})
        .then(response => {
          this.lo = false
          if (response.Durum == "OK") {
            this.ModalOlayi = false;
            this.$message.success(response.Mesaj);
            this.Getir();
          } else {
            this.$message.warning(response.Mesaj);
            this.hata = response.Hata;
          }
        })

    },

    Submit() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true
          if (this.FormData.id) {
            // DÜZENLE
            this.$store.dispatch("Put", {...this.FormData, path: 'muhasebe/virman'})
              .then(response => {
                this.lo = false
                if (response.Durum == "OK") {
                  this.$message.success(response.Mesaj);
                  this.ModalOlayi = false;
                  if (this.tableDisplay) this.Getir();
                } else {
                  this.$message.error(response.Mesaj);

                }
              })
          } else {
            // EKLE
            this.$store.dispatch("Post", {...this.FormData, path: 'muhasebe/virman'})
              .then(response => {
                this.lo = false
                if (response.Durum == "OK") {
                  this.$message.success(response.Mesaj);
                  this.ModalOlayi = false;
                  if (this.tableDisplay) this.Getir();
                } else {
                  this.$message.error(response.Mesaj);

                }
              })
          }

        }
      })
    },
    DuzenleBtn(veri) {
      this.ModalOlayi = true;
      this.Baslik = 'Kasa Virman Düzenle';
      this.FormData = veri
    },
    YeniBtn() {
      this.ModalOlayi = true;
      this.Baslik = 'Yeni Kasa Virman';
      this.FormData = {
        id: null,
        C_Kasa_id: null,
        G_Kasa_id: null,
        Tutar: null,
        iTarihi: new Date(),
        Bina_id: this.Form.Bina_id,
      }
    },
    Getir() {

      this.$refs['FiltreForm'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.$store.dispatch("Post", {...this.Form, path: 'muhasebe/virman/filtre'})
            .then(response => {
              this.lo = false
              if (response.Durum == "OK") {
                this.tableData = response.Data;
                this.tableDisplay = true;
              } else {
                this.$message.error(response.Mesaj);
                this.tableDisplay = false;
              }
            })


        }
      })
    },
    KasaGetir() {
      this.$store.dispatch("Get", {path: 'muhasebe/kasa/' + this.FormData.Bina_id + '/kidem'})
        .then(response => {

          if (response.Durum === 'OK') {
            this.Kasalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    },
    SayfaYukle() {
      this.KasaGetir()
      this.lo = true;
      this.$store.dispatch("Get", {path: 'yonetim/bina'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Binalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.$store.dispatch("Get", {path: 'yonetim/site'})
        .then(response => {
          this.lo = false
          if (response.Durum === 'OK') {
            this.Siteler = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

    },
  },
  created() {
    var Gun = new Date();
    this.Form.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
    this.Form.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);

    if (this.$store.getters.BinaBilgi) {
      this.Bina_id = this.$store.getters.BinaBilgi.id;
      this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
    }
    this.SayfaYukle();
    this.Yetki = this.$store.getters.Yetki.muhasebe == 2 ? true : false;
  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Muhasebe/kasa/Virman.vue